"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _utils = require("../../../utils");

var _index = require("../../../index");

var _upsellDropdown = _interopRequireDefault(require("../upsell-dropdown"));

var _constants = require("./constants");

var _step = _interopRequireDefault(require("./step"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _skeletonLoader = _interopRequireDefault(require("./skeleton-loader"));

var _notification = _interopRequireDefault(require("./notification"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var _ref = /*#__PURE__*/_jsx(_skeletonLoader["default"], {});

var _ref2 = /*#__PURE__*/_jsx(_index.Icon, {
  name: "close",
  color: "#bdc9d2",
  size: 32
});

var _ref3 = /*#__PURE__*/_jsx(_index.Icon, {
  name: "close",
  color: "#fff",
  size: 32
});

var _ref4 = /*#__PURE__*/_jsx(_index.Icon, {
  name: "more",
  color: "#0076ff"
});

var IntegrationGuide = /*#__PURE__*/function (_PureComponent) {
  _inherits(IntegrationGuide, _PureComponent);

  var _super = _createSuper(IntegrationGuide);

  function IntegrationGuide() {
    var _this;

    _classCallCheck(this, IntegrationGuide);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isAssignedTo: false
    });

    _defineProperty(_assertThisInitialized(_this), "getStepsForNotification", function () {
      var activeStepID = _this.props.activeStepID;
      var steps = [];
      var activeStepIndex;

      _this.cardSteps.forEach(function (step, idx) {
        if (step.id === activeStepID) {
          steps.push(step);
          activeStepIndex = idx;
        }
      });

      var nextStep = _this.cardSteps[activeStepIndex + 1];
      nextStep && steps.push(nextStep);
      return steps;
    });

    _defineProperty(_assertThisInitialized(_this), "getNotification", function () {
      var _this$props = _this.props,
          notificationContainerId = _this$props.notificationContainerId,
          _this$props$needNotif = _this$props.needNotification,
          needNotification = _this$props$needNotif === void 0 ? false : _this$props$needNotif,
          onNextStepClick = _this$props.onNextStepClick,
          onFinishGuide = _this$props.onFinishGuide,
          onManualCompleteClick = _this$props.onManualCompleteClick,
          notificationClassName = _this$props.notificationClassName;

      if (!(0, _utils.isClientSide)()) {
        return null;
      }

      var portalContainer = document.getElementById(notificationContainerId);

      if (needNotification && portalContainer !== null) {
        return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_jsx(_notification["default"], {
          steps: _this.getStepsForNotification(),
          onNextStepClick: onNextStepClick,
          onFinishClick: onFinishGuide,
          onManualCompleteClick: onManualCompleteClick,
          className: notificationClassName
        }), portalContainer);
      }
    });

    return _this;
  }

  _createClass(IntegrationGuide, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          card = _this$props2.card,
          onClose = _this$props2.onClose,
          onFinishLater = _this$props2.onFinishLater,
          onStepClick = _this$props2.onStepClick,
          onRequestHelp = _this$props2.onRequestHelp,
          activeStepID = _this$props2.activeStepID,
          fetching = _this$props2.fetching,
          error = _this$props2.error,
          onRefresh = _this$props2.onRefresh,
          className = _this$props2.className,
          stepsRef = _this$props2.stepsRef,
          assignToAM = _this$props2.assignToAM,
          assignToColleague = _this$props2.assignToColleague,
          hideCardLabel = _this$props2.hideCardLabel,
          onAssignToColleague = _this$props2.onAssignToColleague;

      if (fetching) {
        return /*#__PURE__*/_jsx("aside", {
          className: cx('xsui-upsell-integration-guide', className)
        }, void 0, _ref);
      }

      if (error) {
        return /*#__PURE__*/_jsx("aside", {
          className: cx('xsui-upsell-integration-guide', className)
        }, void 0, /*#__PURE__*/_jsx("div", {
          className: cx('xsui-upsell-integration-guide__close'),
          onClick: onClose
        }, void 0, _ref2), /*#__PURE__*/_jsx("div", {
          className: cx('xsui-upsell-integration-guide__error-container')
        }, void 0, /*#__PURE__*/_jsx(_errorMessage["default"], {
          onRefresh: onRefresh
        })));
      }

      if (!card) {
        return null;
      }

      return /*#__PURE__*/_jsx("aside", {
        className: cx('xsui-upsell-integration-guide', className)
      }, void 0, this.getNotification(), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-upsell-integration-guide__close'),
        onClick: onClose,
        "data-id": "close-integration-guide"
      }, void 0, _ref3), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-upsell-integration-guide__image'),
        style: {
          backgroundImage: "url(".concat(card.imageUrl, ")")
        }
      }), /*#__PURE__*/_jsx("section", {
        className: cx('xsui-upsell-integration-guide__content')
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: cx('xsui-upsell-integration-guide__information')
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: cx('xsui-upsell-integration-guide__heading')
      }, void 0, /*#__PURE__*/_jsx("h3", {
        className: cx('xsui-upsell-integration-guide__title')
      }, void 0, card.title), /*#__PURE__*/_jsx(_upsellDropdown["default"], {
        trigger: "click",
        align: "left",
        position: "bottom",
        size: "md",
        onRequestHelp: onRequestHelp,
        onAssignToColleague: onAssignToColleague,
        assignToAM: assignToAM,
        assignToColleague: assignToColleague,
        hideCardLabel: hideCardLabel
      }, void 0, /*#__PURE__*/_jsx("button", {
        type: "button",
        className: cx('xsui-upsell-integration-guide__assistance')
      }, void 0, "Request assistance ", _ref4)), /*#__PURE__*/_jsx("p", {
        className: cx('xsui-upsell-integration-guide__description')
      }, void 0, card.description)), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-upsell-integration-guide__list')
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: cx('xsui-upsell-integration-guide__point-label')
      }, void 0, /*#__PURE__*/_jsx("h4", {
        className: cx('xsui-upsell-integration-guide__label')
      }, void 0, "Setup steps")), /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('upsell-integration-guide__points'),
        ref: stepsRef
      }, this.cardSteps.map(function (step, index) {
        return /*#__PURE__*/_jsx(_step["default"], {
          step: step,
          stepNumber: index + 1,
          isActive: step.id === activeStepID,
          onClick: onStepClick
        }, step.id);
      })))), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-upsell-integration-guide__footer')
      }, void 0, /*#__PURE__*/_jsx(_index.Button, {
        appearance: "flatten",
        onClick: onFinishLater
      }, void 0, /*#__PURE__*/_jsx("p", {
        className: cx('xsui-upsell-integration-guide__button-label')
      }, void 0, "Finish Later")))));
    }
  }, {
    key: "cardSteps",
    get: function get() {
      var card = this.props.card;

      if (!card) {
        return [];
      }

      return [].concat(_toConsumableArray(card.steps), [{
        id: _constants.MANUAL_LAST_STEP_ID,
        title: 'Complete setup',
        description: null,
        url: null,
        isExternal: false,
        contactLocked: false,
        type: _constants.INTEGRATION_GUIDE_STEP.DEFAULT
      }]);
    }
  }]);

  return IntegrationGuide;
}(_react.PureComponent);

_defineProperty(IntegrationGuide, "defaultProps", {
  notificationContainerId: 'integration-guide-notification-portal'
});

var _default = IntegrationGuide;
exports["default"] = _default;